<div class="container">
  <div class="row">
    <div class="col-md-6" style="color:black; padding-top:1%; font-size:1.4em; font-weight:bold ">
      In re Generic Pharmaceuticals Antitrust Litigation
    </div>
    <div class="col-md-6">
      <div class="float-right phoneNumber" style="font-size: 1.4em; padding-top: 3%; font-weight: bold">1-877-316-0171</div>
    </div>
    <div class="col-md-12" style="padding-left:0px; padding-right:0px">
   
    </div>
  </div>
</div>
<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #000042 ">
    <div class="container">
      <button class="navbar-toggler" type="button" style="background-color:white" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/landing']" style="color:white; font-weight:bold">All Classes Page</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/sun-taro-classes-homepage']" style="color:white; font-weight:bold">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color:white; font-weight:bold">File a Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/sun-taro-classes-notice']" style="color:white; font-weight:bold">Notice/FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/sun-taro-classes-courtdocuments']" style="color:white; font-weight:bold">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/sun-taro-classes-espanol']" style="color:white; font-weight:bold">Español</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/sun-taro-classes-contact']" style="color:white; font-weight:bold">Contact Information</a>
          </li>

        </ul>
      </div>
    </div>
  </nav>

</header>
<div class="container" style="border:1px solid #bebaba">
  <div class="row text-center background-bottom">
    <div class="col-md-12 text-center img-fluid" style="margin-top:2%; margin-bottom:2%; padding-right:2%; padding-left:2%">
      <p class="text-center" style="font-size:1.0em; color:white">
        This official website is maintained by the Notice Administrator for <i>In re Generic Pharmaceuticals Antitrust Litigation</i>,
        No. 16-MD-2724 pending in the United States District Court for the Eastern District of Pennsylvania.
      </p>
    </div>
  </div>
  <!--<div class="row mt-4">
    <div class="col-md-12 text-center">-->
  <!--<img src="../assets/Header wo button.png" class="img-fluid" />-->
  <!--<a [routerLink]="'/tpp'">
        <img src="../assets/Button.png" alt="Register for Updates Here" class="img-fluid" style="width: 30%" />
      </a>
    </div>
  </div>-->
  <div class="row background">
    <div class="col-md-12">
      <a [routerLink]="['/home']">
        <img src="../assets/Main with CTA button.png" class="img-fluid" />
      </a>
    </div>
  </div>
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%">
    <div class="col-md-12" style="text-align:justify;">
      <div style="text-align:left; font-size:1.5em">

        The Court has granted final approval of a $200 million Settlement with Sun Pharmaceutical Industries, Inc. (“Sun”) and Taro Pharmaceuticals U.S.A.,
        Inc. (“Taro”) (“Sun/Taro” refers to both entities) in a class action lawsuit (In re Generic Pharmaceuticals Antitrust Litigation, No. 16-MD-2724
        (E.D. Pa.)). The lawsuit claims generic manufacturers violated federal and state antitrust laws, consumer protection statutes, and common law,
        causing End-Payers – including Consumers and Third-Party Payers (“TPPs”) (e.g., entities such as insurers or employers with self-funded prescription
        drug plans) – to pay more than they should have for certain generic drugs (“Named Generic Drugs”). Sun/Taro denies liability. The lawsuit remains
        ongoing against the Non-Settling Defendants.<br/><br/>

        To participate in the settlement, you must submit a claim form online or by U.S. Mail so that it is submitted or postmarked by <b>November 9, 2026</b>.
        Click <a [routerLink]="['/home']">HERE</a> for the claim form. <b>
  Settlement Class members need not sign up with a claims recovery firm or pay another
  firm in order to participate in the settlements</b>.
        <br /><br />
      </div>


      

    </div>
  </div>
  <br />
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="2" style="background-color: #000042; color: white; font-weight: bold; font-size: 1.4em; text-align: center;">
            YOUR LEGAL RIGHTS AND OPTIONS REGARDING THIS SETTLEMENT
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; width: 20% ">
            SUBMIT A CLAIM FORM
          </td>
          <td style="background-color:white; color:#3e4144; width:60%">
            If you want to be eligible to receive money from this Settlement, you must complete and return a Claim Form.
            The Claim Form and information on how to submit it are available <a [routerLink]="['/home']">HERE</a>. (You
            may request that a form be mailed to you by calling 1-877-316-0171.) Claim Forms must be postmarked (if mailed)
            or received (if submitted online) on or before <b>November 9, 2026</b>. If you or a third party requested that you be
            excluded from the Settlement, and if the Court approved that request, then you will not be eligible to receive
            money from the settlement.
          </td>
        </tr>
        <tr>
          <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; ">
            DO NOTHING
          </td>
          <td style="background-color:white; color:#3e4144;">
            If you are a member of the Settlement Class, by doing nothing you will remain in the Settlement Class for this
            Settlement. You will not get a payment from the Settlement and will give up your right to sue Sun or Taro on
            your own for the same legal claims made in this lawsuit. You will be bound by the Settlement.<br/><br/>

            The deadline for you to object to this Settlement has passed, and the deadline to request to be excluded, or
            “opted out” of, the Settlement Class has passed.
          </td>
        </tr>
        <tr>
          <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; ">
            GET MORE INFORMATION
          </td>
          <td style="background-color:white; color:#3e4144;">
            If you would like to obtain more information about the Lawsuit or the Settlement, you can review the materials
            on the <a [routerLink]="'/sun-taro-classes-courtdocuments'">Court Documents</a>  page, call 1-877-316-0171, or
            send questions to the Notice Administrator at  <a href="mailto:info@genericdrugsendpayersettlement.com">info@genericdrugsendpayersettlement.com</a>.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <br />
</div>


<!--<div id="content-mobile">
  <div class="container" style="border:1px solid #bebaba">
    <div class="row text-center background-bottom">
      <div class="col-md-12 text-center img-fluid" style="margin-top:2%; margin-bottom:2%; padding-right:2%; padding-left:2%">
        <p class="text-center" style="font-size:1.0em; color:white">
          This official website is maintained by the Notice Administrator for <i>In re Generic Pharmaceuticals Antitrust Litigation</i>,
          No. 16-MD-2724 pending in the United States District Court for the Eastern District of Pennsylvania.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 background">
        <img src="../assets/Mobile Full graphic.png" [routerLink]="'/registration'" class="img-fluid" />

      </div>
    </div>

    <br />
    <br />
    <div class="row" style="margin-left:5%;margin-right:5%">
      <div class="col-md-12" style="text-align:justify;">
        <p style="font-size:1.0em">

          <ul>
            <li>
              A Settlement totaling $275,000,000 has been reached in a class action lawsuit against Sandoz Inc. and Fougera
              Pharmaceuticals Inc. (“Sandoz”) and other generic manufacturers (the “Non-Settling Defendants”) about how much
              they paid for certain prescription generic drugs.
            </li>
            <li>
              You may be able to recover money from the Settlement if you are a consumer or third-party payor who is in any
              of the 50 United States (except Indiana and Ohio), as well as the District of Columbia, Puerto Rico, and the
              U.S. Virgin Islands, and indirectly purchased, paid, and/or provided reimbursement for some or all of the
              purchase price for any Named Generic Drugs, other than for resale, from May 1, 2009 to December 31, 2019.
            </li>
            <li>
              The deadlines may be amended by Court Order. Please check this website regularly for updates.

            </li>
          </ul>

          The information contained on this website is only a summary. You may download a copy of the full Notice by
          clicking <a href="./assets/Docs/Notice/long-form-notice-sandoz-2025-03-06-final.pdf" target="_blank">here</a>. Since this website is just a summary, you should review the Notice for additional details.<br /><br />

          Your legal rights might be affected by a proposed $275,000,000 Settlement in a class action lawsuit (<i>
            In re Generic
            Pharmaceuticals Antitrust Litigation
          </i>, No. 16-MD-2724) pending in the United States District Court for the Eastern
          District of Pennsylvania. The lawsuit has been brought by End-Payer Plaintiffs ("EPPs") and claims that Sandoz Inc.
          and Fougera Pharmaceuticals Inc. (“Sandoz”) and other generic manufacturers (the “Non-Settling Defendants”) violated
          federal and state antitrust laws, consumer protection statutes, and common law, causing End-Payers – including
          consumers and Third-Party Payers (“TPPs”) (e.g., entities such as insurers or employers with self-funded prescription
          drug plans) – to pay more than they should have for certain prescription generic drugs
          (“<a href="./assets/Docs/Notice/named-generic-drugs.pdf" target="_blank">Named Generic Drugs</a>”).
          Sandoz denies that it is liable to End-Payers. The Court has not decided who is right. The lawsuit remains ongoing
          against the Non-Settling Defendants. For additional details, instructions and answers to frequently asked questions,
          please read the <a href="./assets/Docs/Notice/long-form-notice-sandoz-2025-03-06-final.pdf" target="_blank">Notice</a>.<br /><br />

          The Court will hold a Fairness Hearing on <b>July 23, 2025 at 11:00 a.m</b>. to decide whether to approve the Settlement,
          the Plan of Allocation, and any request for attorneys’ fees, expenses, or service awards. Money will be distributed
          if and after the Court approves the Settlement. The amount and the timing of payment will be based on a Plan of
          Allocation that must be approved by the Court. EPPs’ proposed Plan of Allocation is posted on the Court Documents
          page. The claims process will open at a later date. To receive settlement-related updates, including when claim
          forms are available, you should register on the Registration page or call the toll-free number below.<br /><br />

        <p style="text-align:center">Toll-free number: <b>1-877-316-0171</b></p>

        <b>Who is Included?</b><br /><br />

        You may be an EPP Sandoz Settlement Class Member if:<br /><br />

        You are in any of the 50 United States (except Indiana and Ohio), as well as the District of Columbia, Puerto Rico, and
        the U.S. Virgin Islands, and indirectly purchased, paid, and/or provided reimbursement for some or all of the purchase
        price for any Named Generic Drugs, other than for resale, from May 1, 2009 to December 31, 2019.<br /><br />

        You are NOT a member of the EPP Sandoz Settlement Class if you are among any of the following:<br /><br />

        <ol type="A">
          <li>
            Defendants, their officers, directors, management, employees, subsidiaries and affiliates;
          </li>
          <li>
            all federal governmental entities;
          </li>
          <li>
            all state governmental entities (except for cities, towns, municipalities, counties and other local governmental entities with self-funded prescription drug plans, all of which are included in the class);
          </li>
          <li>
            all governmental Medicaid agencies, private Medicaid managed care organizations, and consumers who were covered by Medicaid for their purchases of Named Generic Drugs;
          </li>
          <li>
            Judges assigned to this case and any members of their immediate families;
          </li>
          <li>
            persons or entities who only purchased Defendants’ Named Generic Drugs for purposes of resale or directly from Defendants;
          </li>
          <li>
            fully insured employers to the extent that they use fully-insured plans (i.e., employers that purchased insurance covering 100% of their reimbursement obligation to members); or
          </li>
          <li>
            pharmacy benefit managers.
          </li>
        </ol>

        If you made purchases that meet the definition of the Settlement Class, but also made purchases that fall within one or more of the exclusions above, you are included in the Settlement Class only with respect to those purchases that meet the definition of the Settlement Class.
      </div>
    </div>
    <br />
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th colspan="2" style="background-color: #000042; color: white; font-weight: bold; font-size: 1.4em; text-align: center;">
              YOUR RIGHTS AND OPTIONS
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; width: 20% ">
              STAY IN THE SETTLEMENT CLASS
            </td>
            <td style="background-color:white; color:#3e4144; width:60%">
              You do not need to do anything now to retain your right to stay in the Settlement Class and/or seek a share of the proposed Settlement.<br /><br />

              You may register <a routerLink="/registration">here</a> for settlement-related updates. Then, if the Court decides to give the proposed Settlement final approval, you will
              be notified by email or mail when a claim form becomes available. Once a claim form is available, you will be able to obtain it from the
              Settlement Website or by calling 1-877-316-0171.
            </td>
          </tr>
          <tr>
            <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; ">
              EXCLUDE YOURSELF FROM THE SETTLEMENT CLASS
            </td>
            <td style="background-color:white; color:#3e4144;">
              You may choose to exclude yourself, or “opt out,” from the Settlement Class. If you decide to exclude yourself, you will not be bound by
              any future decision in this Lawsuit relating to Sandoz. This is the only option that allows you to ever be part of any lawsuit (other than
              this Lawsuit) against Sandoz relating to the legal claims against Sandoz in this case.<br /><br />

              You will not receive a payment from the Settlement if you elect to exclude yourself. Details on how to submit a valid request for exclusion
              are explained in <u>pages 8-10</u> of the <a href="./assets/Docs/Notice/long-form-notice-sandoz-2025-03-06-final.pdf" target="_blank">Notice</a>. Requests for exclusion must be postmarked by <b>May 9, 2025</b>.
            </td>
          </tr>
          <tr>
            <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; ">
              STAY IN THE LAWSUIT BUT OBJECT TO THE SETTLEMENT
            </td>
            <td style="background-color:white; color:#3e4144;">
              If you wish to object to all or any part of the proposed Settlement, you may write to the Court about why you do not like the proposed
              Settlement. Details on how to submit an objection are explained in <u>pages 13-14</u> of the <a href="./assets/Docs/Notice/long-form-notice-sandoz-2025-03-06-final.pdf" target="_blank">Notice</a>. Objections must be received by the Court
              by <b>May 9, 2025</b>.<br /><br />

              If you wish to attend and speak at the Final Fairness Hearing about your objection, then you must notify the Court that you wish to
              attend by filing a Notice of Intention to Appear by <b>May 9, 2025</b> (see instructions in <u>page 15</u> of the <a href="./assets/Docs/Notice/long-form-notice-sandoz-2025-03-06-final.pdf" target="_blank">Notice</a>).
            </td>
          </tr>
          <tr>
            <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; ">
              DO NOTHING
            </td>
            <td style="background-color:white; color:#3e4144;">
              If you are a Settlement Class Member and you do nothing, you will remain in the Settlement Class and be eligible to participate in the
              Settlement as described in the <a href="./assets/Docs/Notice/long-form-notice-sandoz-2025-03-06-final.pdf" target="_blank">Notice</a>, if the Settlement is approved. When the time comes for distribution of the settlement fund, you
              will need to complete, sign, and return a Settlement claim form.<br /><br />

              You may register <a routerLink="/registration">here</a> for settlement-related updates. Then, if the Court decides to give the proposed Settlement final approval, you
              will be notified by email or mail when a claim form becomes available. Once a claim form is available, you will be able to obtain it
              from the Settlement Website or by calling 1-877-316-0171.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
    <div class="row" style="margin-left:5%;margin-right:5%">
      <div class="col-md-12" style="text-align:justify;">
        <p style="font-size:1.0em">

          <b>More Information</b><br /><br />

          This website contains a summary of the Settlement and relevant Court papers. If you have questions about the Settlement or want additional
          information, you should first review the information posted on this Settlement Website. If you still have questions, you may call the
          Notice Administrator at 1-877-316-0171 or contact the attorney or law firm identified on the Contact page of this website.
        </p>
        <br />
      </div>
    </div>

  </div>
</div>-->
